module.exports = __webpack_public_path__ + "../resources/img/ic_ac_combiner.4a8dc657.svg";